export default "__VITE_ASSET__DKUwzP1F__"